import {makeStyles} from '@material-ui/core/styles';

export const VUsuariosStyle = makeStyles((theme) => ({
  center: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  flexEnd: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  contentMargin: {
    margin: "10px 0",
  },
  pageRoot: {
    display: "flex",
    flexDirection: "column",
    paddingBottom: theme.spacing(2),
  },
  title: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
    fontWeight: 600,
  },
  formControl: {
    minWidth: 200,
    width: "100%",
  },
  filterRow: {
    flexWrap: "nowrap",
    [theme.breakpoints.down("xs")]: {
      flexWrap: "wrap",
    },
  },
  tableSection: {
    display: "flex",
    flexDirection: "column",
    minHeight: 280,
    height: `calc(100vh - 300px)`,
    [theme.breakpoints.down("sm")]: {
      height: `calc(100vh - 350px)`,
    },
  },
}));